<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1>Our Story</h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section survey-section-main col-12">
            <div class="container">
                <div class="row">
                    <div class="survey-main-section col-12 float-l">
                        <div class="row">
                            <div class="">
                                <video v-if="s3Initial != ''" style="width: 100%;" controls="controls" preload="metadata">
                                    <source :src="s3Initial + 'our_story/VelocityVehicleGroupVVGAboutUs.mp4#t=0.1'" type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import VueFrame from 'vue-frame';
    var self;
    export default {
        name: 'Surveys',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'v-frame': VueFrame,
        },
        data() {
            return {
                FirstLoad: true,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                s3Initial: "",
            }
        },
        beforeMount: function () {
            self = this;
            self.role.id = 0;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getInitials();
            self.getPermissions();
            self.getBuildVersion();
        },
        watch: {
            
        },

        methods: {
            
            getInitials() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    /*params: {
                        role_id: roleId,
                        location_id: locationId,
                    }*/
                };

                HTTP.get("getinitials", config)
                        .then(function (response) {
                            self.s3Initial = "";
                            setTimeout(function () {
                                self.s3Initial = response.data.content.s3_initial;
                            }, 100);
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/OurStories.vue